import React, { Component } from "react";

const UswfList = ({ content }) => {
  const isKeyAListItem = (key) =>
    key === "firstListItem" ||
    key === "secondListItem" ||
    key === "thirdListItem" ||
    key === "fourthListItem" ||
    key === "fifthListItem";

  const sortListItems = (choice1, choice2) => {
    if (choice1 === "firstListItem") return -1;
    if (choice2 === "firstListItem") return 1;
    if (choice1 === "secondListItem") return -1;
    if (choice2 === "secondListItem") return 1;
    if (choice1 === "thirdListItem") return -1;
    if (choice2 === "thirdListItem") return 1;
    if (choice1 === "fourthListItem") return -1;
    if (choice2 === "fourthListItem") return 1;
    if (choice1 === "fifthListItem") return -1;
    if (choice2 === "fifthListItem") return 1;
    //for button title
    return 0;
  };

  const filteredList = Object.keys(content).filter(isKeyAListItem);
  filteredList.sort(sortListItems);
  const sortedList = filteredList.map((key) => content[key]);

  return filteredList.length ? (
    <ul className="uswf-list">
      {sortedList.map((listItem) => (
        <li key={listItem} className="uswf-list-item">
          {listItem}
        </li>
      ))}
    </ul>
  ) : null;
};

export default UswfList;
